/** Offering ID for the BHG Check-in Assist product (matches manifest.json). */
export const BHG_OFFERING_ID = "bhg-call" as const;
